import { byRanking } from "./byRanking";

export function getFavoriteTournamentsData(sports, favoritesMap, currentFilter) {
    let favoriteTournaments = [];
    let tournamentsCount = 0;
    let tournamentsIds = [];
    sports.forEach(sport => {
        if (sport.filters[currentFilter] !== undefined) {
            const tournaments = [];
            sport.categories.forEach(country => {
                country.tournaments.filter(tournament => {
                    return tournament.filters[currentFilter] !== undefined && favoritesMap[tournament.uniqueId] !== undefined;
                }).forEach(tournament => {
                    tournaments.push({
                        id: tournament.id,
                        uniqueId: tournament.uniqueId,
                        descrizione: tournament.descrizione,
                        categoryRef: tournament.categoryRef,
                        sportRef: tournament.sportRef,
                        isLive: tournament.isLive,
                        eventsCount: tournament.eventsCount,
                        iconClass: tournament.iconClass,
                        categoryIcon: tournament.categoryIcon,
						sportUrlPath: tournament.sportUrlPath,
						sportUrlPathSuffix: tournament.sportUrlPathSuffix,
						categoryUrlPath: tournament.categoryUrlPath,
						categoryUrlPathSeo: tournament.categoryUrlPathSeo,
						categoryUrlPathSeoSettings: tournament.categoryUrlPathSeo,
						categoryUrlPathSuffix: tournament.categoryUrlPathSeo,
						urlPath: tournament.urlPath,
						urlPathSeo: tournament.urlPathSeo,
						urlPathSeoSettings: tournament.urlPathSeoSettings,
						urlPathSuffix: tournament.urlPathSuffix
                    });
                    tournamentsIds.push(tournament.uniqueId);
                    tournamentsCount++;
                });
            });
            if (tournaments.length > 0) {
                favoriteTournaments.push({
                    id: sport.id,
                    iconClass: sport.iconClass,
                    descrizione: sport.descrizione,
                    competitions: tournaments,
                });
            }
        }
	});
	
	return {
		sportsList: favoriteTournaments.sort(byRanking),
		tournamentsIds,
		tournamentsCount
	}
}
